import Vue from 'vue'

export default {
  payment: {
    list (params = []) {
      return Vue.axios.get('/reports/payment', { params })
        .then((response) => response.data)
    },

    download (params = []) {
      return Vue.axios.get('/reports/payment/download',
        {
          params,
          responseType: 'blob',
          headers: { 'Accept': 'application/vnd.ms-excel' }
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'data.xlsx')
          document.body.appendChild(link)
          link.click()
        })
    }
  },

  sale: {
    list (params = []) {
      return Vue.axios.get('/reports/sale', { params })
        .then((response) => response.data)
    },

    download (params = []) {
      return Vue.axios.get('/reports/sale/download',
        {
          params,
          responseType: 'blob',
          headers: { 'Accept': 'application/vnd.ms-excel' }
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'data.xlsx')
          document.body.appendChild(link)
          link.click()
        })
    }
  },

  shipment: {
    list (params = []) {
      return Vue.axios.get('/reports/shipment', { params })
        .then((response) => response.data)
    },

    download (params = []) {
      return Vue.axios.get('/reports/shipment/download',
        {
          params,
          responseType: 'blob',
          headers: { 'Accept': 'application/vnd.ms-excel' }
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'data.xlsx')
          document.body.appendChild(link)
          link.click()
        })
    }
  }
}
